import React from 'react';
import './App.css';
import RewardCodeForm from './RewardCodeForm';

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT || 'https://production';

function refreshPage() {
    window.location.reload(false);
  }

interface ServerData {
  result: string;
  name: string;
  contents: string;
};

interface AppState {
  serverData: ServerData | null;
  validError: string | null;
  serverError: string | null;
  isBusy: boolean;
};

class RewardBundle extends React.Component<any, AppState> {


  constructor(props: any) {
    super(props);
    this.state = {
      serverData: null,
      validError: null,
      serverError: null,
      isBusy: false
    };
  }

  async componentDidMount() {
    this.setState({
      
    });
  }

  async redeem(name: string, password: string, code: string) {
    this.setState({
      serverError: null,
      validError: null,
      isBusy: true
    });

    const form = new FormData();
    form.append("Name", name);
    form.append("Password", password);
    form.append("Code", code);

    const resp = await fetch(API_ENDPOINT + "/NewAccount/RedeemRewardBundle", {
      method: "POST",
      body: form,
    });

    console.log(resp);

    const text = await resp.clone().text();

    resp.json()
      .then(data => {
        console.log(data);
        this.setState({
          serverData: data,
          isBusy: false
        });
      })
      .catch(e => {
        this.setState({
          serverError: text.startsWith("EX") ? text.slice("EX".length) : text,
          isBusy: false
        });
      });
  }
    
  render() {
    const errorText = this.state.validError
      ? this.state.validError
      : this.state.serverError
      ? this.state.serverError
      : null;

	if(this.state.serverData === null || this.state.serverData === undefined) {
            console.log('serverData is null');
	}
	else
	{
	console.log(this.state.serverData.contents);
	}
	

    const message = this.state.serverData
      ? <div className="success">
          <p>You have successfully claimed your reward bundle!</p>
		  <div dangerouslySetInnerHTML={{ __html: this.state.serverData.contents }}></div>
          <p>Please open the app and tap Restore Purchases to sync all of the bundle items.</p>
		  <p><button type="button" className="btn btn-primary" onClick={refreshPage}>Claim Another Code</button></p>
		  <div className="links_container">
            <a className="storelogo" href="https://itunes.apple.com/us/app/star-realms/id893447125?mt=8/">
              <img alt="Download on the App Store" src="/Apple_Platform_Badge_Layout_Horizontal.png"/>
            </a>
			<a className="storelogo" href="https://play.google.com/store/apps/details?id=com.starrealms.starrealmsapp&hl=en&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1">
              <img alt="Get it on Google Play" src="/Google_Platform_Badge_Layout_Horizontal.png"/>
            </a>
			<a className="storelogo" href="https://store.steampowered.com/app/438140/">
              <img alt="Get it on Steam" src="/Steam_Platform_Badges_Layout_Horizontal_White.png"/>
            </a>
          </div>
		  <p><a className="banner" href="https://apps.apple.com/us/app/star-realms/id1066107760?ls=1&mt=12">Star Realms is also available on the Mac App Store</a></p>
          <p className="smalltext">Apple, the Apple logo, and App Store are trademarks of Apple Inc., registered in the U.S. and other countries. Google Play is a trademark of Google LLC. Steam and the Steam logo are trademarks and/or registered trademarks of Valve Corporation in the U.S. and/or other countries.</p>
        </div>
      : null;

    const form = this.state.serverData ? null : (
      <RewardCodeForm
        errorText={errorText}
        onValidError={e => this.setState({validError: e})}
        submitCallback={(n,p,c) => this.redeem(n,p,c)}
        disableRegistration={this.state.isBusy}/>
    );

    return (
      <>
            { message }
            { form }
          
      </>
    );  
  }
}

export default RewardBundle;
